import { createContext, useContext } from 'react';

import { UserInfo } from '../../models/IUserDetails';

export const UserContext = createContext<UserInfo | undefined>(undefined);

//export interface Context extends UserClaims {}

export const useUserContext = (): UserInfo => useContext(UserContext) as UserInfo;
